import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import { AuthContext } from '../../../providers/AuthProvider';

export const SignedInAs = () => {
	const { user } = useContext(AuthContext);
	return (
		<Box>
			<Typography
				variant="h6"
				sx={{ color: 'text.secondary', fontStyle: 'normal' }}
			>
				Signed in as{' '}
				<Box
					component="span"
					sx={{
						color: 'text.secondary',
						fontWeight: 500,
						fontStyle: 'normal',
					}}
				>
					{user?.email}
				</Box>
			</Typography>
		</Box>
	);
};
